<template>
  <loader-wrapper :loading="loadingAdmin" custom-class="customClass">
    <el-select :value="id" placeholder="Кому назначена" @change="onSelect">
      <el-option
        v-for="admin in admins"
        :key="admin.id"
        :label="admin.fio || '(нет данных)'"
        :value="admin.id"
      />
    </el-select>
  </loader-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'

export default {
  name: 'AdminSelect',
  components: { LoaderWrapper },
  props: {
    customClass: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: null,
    },
  },
  computed: {
    ...mapGetters({
      getList: 'callCenter/getList',
      getLoading: 'callCenter/getLoading',
    }),
    admins() {
      return this.getList('admins')
    },
    loadingAdmin() {
      return this.getLoading('Admin')
    },
  },
  methods: {
    onSelect(val) {
      this.$emit('change', val)
    },
  },
}
</script>
